import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IRegister, RateNames } from "./meterRegister.types"
import { Register } from "./meterRegister"
import {
  MeterReadingParser,
  IReadingRaw,
} from "../meterReading/meterReading.parser"
import type { IMeterRaw } from "../meter/meter.parser"

export type IRegisterRaw = NonNullable<IMeterRaw["registers"][number]>

function parseRateName(input: string): RateNames {
  const normalized = input.trim().toLowerCase()

  switch (normalized) {
    case "standard":
      return "Standard"
    case "day":
      return "Day"
    case "night":
      return "Night"
    default:
      return null
  }
}
export const MeterRegisterParser: IParser<IRegister, IRegisterRaw> = {
  toDomain: (rawRegister: IRegisterRaw) => {
    try {
      return new Register(
        rawRegister.id,
        rawRegister.identifier,
        parseRateName(rawRegister.rateName),
        Number(rawRegister.usage),
        rawRegister.readings
          .filter((reading): reading is IReadingRaw => reading !== null)
          .map((reading) => MeterReadingParser.toDomain(reading)),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
